var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12864 2H9.87131V2.65625H13V4H12.3566V12.6562C12.3566 13.0312 12.2299 13.3542 11.9766 13.625C11.7426 13.875 11.46 14 11.1286 14H4.87134C4.53995 14 4.24755 13.875 3.99415 13.625C3.76023 13.3542 3.64327 13.0312 3.64327 12.6562V4H3V2.65625H6.12864V2ZM4.87134 4V12.6562H11.1286V4H4.87134ZM6.12864 5.34375H7.38594V11.3438H6.12864V5.34375ZM8.61401 5.34375H9.87131V11.3438H8.61401V5.34375Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditDelete);
export default __webpack_public_path__ + "static/media/icon_edit_delete.9066d08de6ccea84090eee52bd65e72c.svg";
export { ForwardRef as ReactComponent };